import styled from 'styled-components'

export const StyledTableCol = styled.div`
	flex-basis: ${({ theme: { sectionColWidth, sectionColPadding } }) => `calc(${sectionColWidth.normal} - ${sectionColPadding} * 2)`};
`
